import { render } from "./Boxes.vue?vue&type=template&id=6f87675e"
import script from "./Boxes.vue?vue&type=script&lang=js"
export * from "./Boxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__